import { getExecutingEnvironment } from "@app/resolveModule/env";

export type AgentMode = "readOnly" | "full";

export const getAgentMode = (): AgentMode => (getExecutingEnvironment() === "next" ? "readOnly" : "full");
